import { useQuery } from '@tanstack/react-query'
import { dispatcherService } from '@/api/services/dispatcherService'
import { createApiRetryHandler } from '@/utils/apiRetry'

export const useGetAllDispatchers = () => {
  return useQuery({
    queryKey: ['dispatchers'],
    queryFn: () => dispatcherService.getAllDispatchers(),
    staleTime: 10 * 60 * 1000, // 10 minutes - data is fresh for 10 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes - cache for 30 minutes after becoming stale
    retry: createApiRetryHandler(5),
  })
}

export const useGetDispatcher = (dispatcherId: string) => {
  return useQuery({
    queryKey: ['dispatchers', dispatcherId],
    queryFn: () => dispatcherService.getDispatcher(dispatcherId),
    enabled: !!dispatcherId,
    staleTime: 10 * 60 * 1000, // 10 minutes - data is fresh for 10 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes - cache for 30 minutes after becoming stale
    retry: createApiRetryHandler(5),
  })
}
